import NextDocument, {
  DocumentContext,
  DocumentInitialProps,
  Head,
  Html,
  Main,
  NextScript,
} from 'next/document';
import { ServerStyleSheet } from 'styled-components';

import { Fonts } from '@bolttech/essentials/src/components';

export default class Document extends NextDocument {
  static locale: string;
  static font: string;

  static async getInitialProps(
    ctx: DocumentContext,
  ): Promise<DocumentInitialProps> {
    const sheet = new ServerStyleSheet();
    const originalRenderPage = ctx.renderPage;

    try {
      ctx.renderPage = () =>
        originalRenderPage({
          enhanceApp: (App) => (props) =>
            sheet.collectStyles(<App {...props} />),
          enhanceComponent: (Component) => (props) =>
            sheet.collectStyles(<Component {...props} />),
        });

      const initialProps = await NextDocument.getInitialProps(ctx);

      Document.locale = initialProps.head?.find(
        (item) => item?.props?.name === 'locale',
      )?.props?.content;

      Document.font = initialProps.head?.find(
        (item) => item?.props?.name === 'font',
      )?.props?.content;

      return {
        ...initialProps,
        styles: (
          <>
            {initialProps.styles}
            {sheet.getStyleElement()}
          </>
        ),
      };
    } finally {
      sheet.seal();
    }
  }

  render(): JSX.Element {
    return (
      <Html lang={Document.locale}>
        <Head>{(Document.font && <Fonts font={Document.font} />) || null}</Head>
        <body>
          <Main />
          <NextScript />
        </body>
      </Html>
    );
  }
}
